module.exports = __webpack_public_path__ + "static/media/10.288953aa.jpg";